import { consoleApiSlice } from "./consoleApiSlice";

export const agentOperationsApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAgentOpsStatus: builder.query({
      query: () => ({ url: "/agent-operations/status", method: "GET" }),
      providesTags: ["AgentOpsStatus"],
    }),

    getAgentOpsAgents: builder.query({
      query: () => ({ url: "/agent-operations/agents", method: "GET" }),
      providesTags: ["AgentOpsAgents"],
    }),

    getAgentOpsBatches: builder.query({
      query: () => ({ url: "/agent-operations/batches", method: "GET" }),
      providesTags: ["AgentOpsBatches"],
    }),

    launchAgentOpsBatch: builder.mutation({
      query: (body) => ({
        url: "/agent-operations/launch-batch",
        method: "POST",
        body,
      }),
      invalidatesTags: ["AgentOpsBatches"],
    }),

    searchAgentOpsWebsites: builder.query({
      query: (q) => ({ url: `/agent-operations/websites/search?q=${encodeURIComponent(q)}`, method: "GET" }),
    }),

    getAgentOpsConfigs: builder.query({
      query: () => ({ url: "/agent-operations/configs", method: "GET" }),
      providesTags: ["AgentOpsConfigs"],
    }),

    saveAgentOpsConfig: builder.mutation({
      query: (body) => ({ url: "/agent-operations/configs", method: "POST", body }),
      invalidatesTags: ["AgentOpsConfigs"],
    }),

    deleteAgentOpsConfig: builder.mutation({
      query: (configId) => ({ url: `/agent-operations/configs/${configId}`, method: "DELETE" }),
      invalidatesTags: ["AgentOpsConfigs"],
    }),

    refreshAgentOps: builder.mutation({
      query: () => ({ url: "/agent-operations/refresh", method: "POST" }),
      invalidatesTags: ["AgentOpsBatches"],
    }),

    getGroupingOverview: builder.query({
      query: (env = "staging") => ({
        url: `/agent-operations/grouping/overview?env=${env}`,
        method: "GET",
      }),
      providesTags: (result, error, env) => [{ type: "AgentOpsGrouping", id: env || "staging" }],
    }),

    getGroupingWebsite: builder.query({
      query: ({ websiteId, env = "staging" }) => ({
        url: `/agent-operations/grouping/website/${websiteId}?env=${env}`,
        method: "GET",
      }),
      providesTags: (result, error, { websiteId }) => [{ type: "AgentOpsGroupingWebsite", id: websiteId }],
    }),

    getGroupingLogs: builder.query({
      query: ({ websiteId, env = "staging" }) => ({
        url: `/agent-operations/grouping/website/${websiteId}/logs?env=${env}`,
        method: "GET",
      }),
      providesTags: (result, error, { websiteId }) => [{ type: "AgentOpsGroupingLogs", id: websiteId }],
    }),

    getGroupingHistory: builder.query({
      query: (env = "staging") => ({
        url: `/agent-operations/grouping/history?env=${env}`,
        method: "GET",
      }),
      providesTags: (result, error, env) => [{ type: "AgentOpsGroupingHistory", id: env || "staging" }],
    }),

    regroupWebsite: builder.mutation({
      query: ({ websiteId, mode, env = "staging" }) => ({
        url: `/agent-operations/grouping/website/${websiteId}/regroup?env=${env}`,
        method: "POST",
        body: { mode },
      }),
      invalidatesTags: (result, error, { websiteId, env = "staging" }) => [
        { type: "AgentOpsGrouping", id: env },
        { type: "AgentOpsGroupingWebsite", id: websiteId },
        { type: "AgentOpsGroupingLogs", id: websiteId },
        { type: "AgentOpsGroupingHistory", id: env },
      ],
    }),

    regroupAllPartials: builder.mutation({
      query: (env = "staging") => ({
        url: `/agent-operations/grouping/regroup-all-partials?env=${env}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, env) => [
        { type: "AgentOpsGrouping", id: env || "staging" },
        { type: "AgentOpsGroupingHistory", id: env || "staging" },
      ],
    }),
  }),
});

export const {
  useGetAgentOpsStatusQuery,
  useGetAgentOpsAgentsQuery,
  useGetAgentOpsBatchesQuery,
  useLaunchAgentOpsBatchMutation,
  useRefreshAgentOpsMutation,
  useGetGroupingOverviewQuery,
  useGetGroupingWebsiteQuery,
  useGetGroupingLogsQuery,
  useGetGroupingHistoryQuery,
  useRegroupWebsiteMutation,
  useRegroupAllPartialsMutation,
  useGetAgentOpsConfigsQuery,
  useSaveAgentOpsConfigMutation,
  useDeleteAgentOpsConfigMutation,
  useSearchAgentOpsWebsitesQuery,
} = agentOperationsApiSlice;
